import { booking as apiBooking } from '../../api'

export const BOOKINGS_START_SEARCH = 'BOOKINGS_START_SEARCH'
export const BOOKINGS_FAILURE_SEARCH = 'BOOKINGS_FAILURE_SEARCH'
export const BOOKINGS_SUCCESS_SEARCH = 'BOOKINGS_SUCCESS_SEARCH'
export const BOOKINGS_UPDATED_FILTERS = 'BOOKINGS_UPDATED_FILTERS'
export const BOOKINGS_SELECT_BOOKING = 'BOOKINGS_SELECT_BOOKING'
/**
 * Start search bookings
 */
const startSearch = () => ({ type: BOOKINGS_START_SEARCH })

/** Set bookings success search */
const setBookingsSuccess = (data) => ({ type: BOOKINGS_SUCCESS_SEARCH, payload: data })

/**
 * Search bookings by filters
 */
const searchBookings = (filters = {}) => (dispatch, getState) => {
  dispatch(startSearch())

  const { searchBooking, brands, companies, delegations } = getState()

  // Get brands, delegations, company, and channels from reducers
  const allBrands = Object.keys(brands)
  const allDelegations = Object.keys(delegations)
  const allChannels = companies.channels.map((c) => c.channel)

  const company = companies._id

  const newFilters = { ...searchBooking, ...filters }
  const {
    bookedForDate,
    bookedOn,
    issueDateLimit,
    limit,
    page,
    pnrLocator,
    reservationStatus,
    textToSearch,
    type,
    providers = [],
    channels: selectedChannels = [],
    brands: selectedBrands = [],
    delegations: selectedDelegations = [],
    sortByField,
    sortType,
  } = newFilters

  const queryFilters = {
    limit,
    page,
    pnrLocator,
    reservationStatus,
    textToSearch,
    type,
    bookedForDate: `${bookedForDate[0] || null},${bookedForDate[1] || null}`,
    bookedOn: `${bookedOn[0] || null},${bookedOn[1] || null}`,
    issueDateLimit: `${issueDateLimit[0] || null},${issueDateLimit[1] || null}`,
    channels: allChannels?.length > 0 && selectedChannels?.length === 0 ? allChannels.join() : selectedChannels?.map((el) => el.value).join(),
    brands: allBrands?.length > 0 && selectedBrands?.length === 0 ? allBrands.join() : selectedBrands?.map((el) => el.value).join(),
    delegations:
      allDelegations?.length > 0 && selectedDelegations?.length === 0 ? allDelegations.join() : selectedDelegations?.map((el) => el.value).join(),
    providers: providers && providers?.length > 0 ? providers?.map((el) => el.value).join() : '',
    company,
    sortByField,
    sortType,
  }

  // send new filters as params
  apiBooking
    .getBookings(queryFilters)
    .then(({ data, status }) => {
      if (status === 200) {
        dispatch(setBookingsSuccess(data))
      }
    })
    .catch((error) => console.error('TCL: error', error))
}

/**
 * Update filters
 * @param {string} field
 * @param {*} value
 */
const updateBookingsFilters = (field, value) => (dispatch) => {
  dispatch({ field, value, type: BOOKINGS_UPDATED_FILTERS })
  dispatch(searchBookings({ [field]: value }))
}

/**
 * Update filters
 * @param {string} field
 * @param {*} value
 */
const resetBookingsFilters = (field, value) => (dispatch) => {
  dispatch({ field, value, type: BOOKINGS_UPDATED_FILTERS })
}

/**
 * Update text
 * @param {string} field
 * @param {*} value
 */
const selectAllBookings = (bookings, checked) => (dispatch) => dispatch({ bookings, checked, type: BOOKINGS_SELECT_BOOKING })


const updateBookingsSearchText = (field, value) => (dispatch) => dispatch({ field, value, type: BOOKINGS_UPDATED_FILTERS })
/**
 * Check or Uncheck cols to show
 * @param {string} value
 */
const setColsToShow = (value, position) => (dispatch, getState) => {
  const { colsToShow } = getState().searchBooking

  const indexCols = colsToShow.indexOf(value)

  if (indexCols === -1) {
    colsToShow.splice(position, 0, value)
  } else {
    colsToShow.splice(indexCols, 1)
  }

  dispatch({ field: 'colsToShow', value: [...colsToShow], type: BOOKINGS_UPDATED_FILTERS })
}

/** Get detailed booking */
const getDetailedBooking = (bookingId) => {
  return apiBooking
    .getDetailedBooking(bookingId)
    .then(({ data, status }) => {
      if (status === 200) {
        return data.results || {}
      } else if (status === 204) {
        return {}
      }
    })
    .catch((error) => {
      console.error(error)
      return {}
    })
}

/** Get detailed booking with updateFromApi */
const getDetailedBookingFromApi = (bookingId, updateFromApi) => {
  return apiBooking
    .getDetailedBookingFromApi(bookingId, updateFromApi)
    .then(({ data, status }) => {
      if (status === 200) {
        return data.results || {}
      } else if (status === 204) {
        return {}
      }
    })
    .catch((error) => {
      console.error(error)
      return {}
    })
}

/**
 * Define booking actions
 */
const bookingAction = ({ action, data, method }) => {
  switch (action) {
    case 'cancel': {
      return apiBooking.cancelBooking(data, method)
    }
    case 'void': {
      return apiBooking.voidBooking(data, method)
    }
    case 'emit': {
      return apiBooking.emitBooking(data, method)
    }
    case 'modify': {
      return apiBooking.modifyBooking(data, method)
    }
    default: {
      return Promise.resolve()
    }
  }
}

/** Get detailed booking */
const getBookingUser = (userId) => {
  return apiBooking.getBookingByUser(userId)
    .then(({ data, status }) => {
      if (status === 200) {
        return data || []
      } else if (status === 204) {
        return []
      }
    })
    .catch((error) => {
      console.error(error)
      return []
    })
}

export default {
  searchBookings,
  setColsToShow,
  updateBookingsFilters,
  updateBookingsSearchText,
  getDetailedBooking,
  bookingAction,
  getDetailedBookingFromApi,
  resetBookingsFilters,
  getBookingUser,
  selectAllBookings
}
